import {Divider, styled} from '@mui/material';

type CustomDividerProps = {
	$size?: 'md' | 'sm';
};

export const CustomDivider = styled(Divider)<CustomDividerProps>`
	margin-top: ${({$size}) => {
		if (!$size) {
			return 16;
		}
		return $size === 'md' ? 16 : 8;
	}}px;
`;
